.header-text-center {
    flex: 1;
    text-align: center;
}

/* Matches width of back button in order to center text within the header */
.header-layout-block {
    width: 55px;
}
